// extracted by mini-css-extract-plugin
module.exports = {"container_translate":"typetranslate_container_translate__1dJs_","item_translate":"typetranslate_item_translate__1yjUO"};